import React, { Component } from 'react';
import Register from './Register';
import { accountActions } from '../../../actions/account.action';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import Loading from '../../Helpers/Loading';
import Empty from '../../Layouts/Empty';

export class RegisterContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      invitationInfo: {},
      invitationId: this.props.match.params.invitationId,
      error: '',
    };
    this.props.logout();
    localStorage.removeItem('userInfo');
  }

  componentDidMount() {
    const { invitationId } = this.state;
    this.props.queryInvitation(invitationId);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let state = {};
    if (nextProps.account.invitationInfo !== prevState.invitationInfo) {
      state.invitationInfo = nextProps.account.invitationInfo;
    }
    if (nextProps.account.errorText !== prevState.error) {
      state.error = nextProps.account.errorText;
    }
    if (nextProps.account.loading !== prevState.loading) {
      state.loading = nextProps.account.loading;
    }
    return Object.keys(state) ? state : null;
  }

  submitRegister = (...resp) => {
    this.props
      .register(...resp, this.state.invitationId)
      .then(() => this.props.history.push('/login'))
      .catch((err) => console.log(err));
  };

  render() {
    const { invitationInfo, error, loading } = this.state;
    const _error = [];
    if (!isEmpty(error)) {
      for (var key in error) {
        _error.push(error[key]);
      }
    }
    if (loading) {
      return (
        <Empty>
          <Loading />
        </Empty>
      );
    }
    return (
      <Register
        invitationInfo={invitationInfo}
        error={_error.join('\n')}
        onRegister={this.submitRegister}
        loading={loading}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    account: state.account,
  };
}

export default connect(mapStateToProps, accountActions)(RegisterContainer);
